export default class InputWithCurrentLocationButton {
	constructor(container) {
		this.button = container.querySelector('button');
		this.input = container.querySelector('input');

		this.button.addEventListener('click', () => {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(position => {
					this.input.geo_point.update_address({
						lat: position.coords.latitude, lng: position.coords.longitude
					});
				});
			} else {
				alert('Geolocation is not supported by this browser.');
			}
		});
	}
}
